import { get, writable } from 'svelte/store';

import { PushHistoryService } from '@client/services/push-history';

const days = writable(90); // Default value of 90 days
const history = writable([]);
const loadingHistory = writable(false);

const fetchPushHistory = async (daysValue) => {
  loadingHistory.set(true);
  try {
    const pushHistory = await PushHistoryService.get({ days: daysValue });
    const filtered = pushHistory.filter((entry) => entry.action === 'pushbizcard');

    history.set(filtered);
  } catch (error) {
    console.error('Failed to fetch push history', error);
    history.set([]); // Handle errors by setting a default value
  } finally {
    loadingHistory.set(false);
  }
};

let daysSubscribed = false;

const createPushHistoryStore = () => {
  const { subscribe } = history;

  return {
    subscribe(run) {
      if (!daysSubscribed) {
        daysSubscribed = true;
        // days.subscribe fires immediately with the current value, covering the initial fetch,
        // and again whenever `days` changes.
        days.subscribe(fetchPushHistory);
      }
      return subscribe(run);
    }
  };
};

const updatePushHistory = () => {
  fetchPushHistory(get(days));
};

export const pushHistory = createPushHistoryStore();
export { days, loadingHistory, updatePushHistory };
